import Time from 'react-time';
import React from 'react';
import { connect } from 'react-redux';
import pluralize from 'pluralize';
import { selectOrganization } from '../../../../modules/organizations.js';
import { getOrgTermsContent } from '../../../../content/utils.js';
import VerticalSeparator from '../../../VerticalSeparator.jsx';
import { LeadIcon } from '../../../icons/LeadIcon.jsx';
import { ClockIcon } from '../../../icons/ClockIcon.jsx';
import { ShowMoreItemsHeader } from '../../../projects/ChangeStrategy/ChangeStrategyOverview/ShowMoreItemsHeader.jsx';
import { HandshakeBlueIcon } from '../../../icons/HandshakeBlueIcon.jsx';
import PortfolioIcon from '../../../icons/PorfolioIcon.jsx';
import ParentPortfolioIcon from '../../../icons/ParentPorfolioIcon.jsx';

const mapStateToProps = (state) => ({
  organization: selectOrganization(state),
});

const PortfolioViewHeader = ({ portfolio, projectStatuses, organization }) => {
  const {
    name,
    owners,
    projects,
    sponsors,
    project_status_id,
    start_date,
    end_date,
    parent_portfolio_name,
  } = portfolio;

  const status = projectStatuses.find((s) => s.id === project_status_id);
  return (
    <div className="component component-bg-white">
      <div className="flex">
        {organization && organization.hasParentPortfolios ? (
          <React.Fragment>
            <div className="flex header-item">
              <ParentPortfolioIcon />
              <strong className="text-muted m-r-12 m-l-8">
                {getOrgTermsContent('parentPortfolio')}:{' '}
              </strong>
              <strong>
                <strong>{parent_portfolio_name || '—'}</strong>
              </strong>
            </div>
            <VerticalSeparator />
          </React.Fragment>
        ) : null}
        <div className="flex header-item">
          <PortfolioIcon />
          <strong className="text-muted m-r-12 m-l-8">
            {getOrgTermsContent('portfolio')}:{' '}
          </strong>
          <strong>{name}</strong>
        </div>
        <VerticalSeparator />
        <div className="flex header-item">
          <LeadIcon />
          <strong className="text-muted m-r-12 m-l-8">
            {pluralize('Owner', owners.length)}:
          </strong>
          {owners.length ? (
            <ShowMoreItemsHeader items={owners} maxShowNumber={2} />
          ) : (
            '—'
          )}
        </div>
        <VerticalSeparator />
        <div className="flex header-item">
          <ClockIcon />
          <strong className="text-muted m-r-12 m-l-8">Dates: </strong>
          {start_date && end_date ? (
            <React.Fragment>
              <strong>
                <Time value={start_date} format="M/D/YY" />
              </strong>
              <strong>
                <span>&nbsp;- </span>
                <Time value={end_date} format="M/D/YY" />
              </strong>
            </React.Fragment>
          ) : (
            '—'
          )}
        </div>
        <VerticalSeparator />
        <div className="flex header-item">
          <strong className="text-muted m-r-12">
            {getOrgTermsContent('numberProjects')}:{' '}
          </strong>
          <strong>{projects ? projects.length || '—' : '—'}</strong>
        </div>
      </div>
      <div className="flex header-row">
        <div className="flex header-item">
          <HandshakeBlueIcon />
          <strong className="text-muted m-r-12 m-l-8">
            {pluralize('Sponsors', sponsors.length)}:{' '}
          </strong>
          {sponsors.length ? (
            <ShowMoreItemsHeader items={sponsors} maxShowNumber={2} />
          ) : (
            '—'
          )}
        </div>
        <VerticalSeparator />
        <div className="flex header-item">
          <strong className="text-muted m-r-12">Status: </strong>
          <strong className={`${status.archived ? 'text-muted' : ''}`}>
            {status.name}
          </strong>
        </div>
      </div>
    </div>
  );
};

export default connect(mapStateToProps)(PortfolioViewHeader);
